import React from 'react';
import anime from 'animejs/lib/anime.es.js';

export default class Circle extends React.Component{

  componentDidMount(){
    this.startAnimation();
  }

  startAnimation(){
    if(this.props.animated){
      anime({
        targets: this.c,
        rotateZ: 360,
        easing: 'linear',
        loop: true,
        opacity: [1, 0, 1],
        duration: 18000,
      })
    }


  }

  render(){
    return null;
    var cs = ['gradientcircle'];
    if(this.props.dark){
      cs.push('darkcircle');
    }

    return(
      <div className={cs.join(' ')} ref={(ref) => this.c = ref}>
        <div className="gradientcircle_circle"></div>
      </div>
    )
  }
}
